import { useLingui } from '@lingui/react/macro';
import { Trans } from '@lingui/react/macro';
import { useNgoAreaUrl } from '@/lib/ngo-area';
import { DiamondGrid, diamondGlows, PillLink } from '../primitives';

/** For an NGO already partnered. The mockup overflowing the right edge is the hand-off's, on purpose. */
export function NgoAreaBand() {
	const { t } = useLingui();
	const ngoArea = useNgoAreaUrl();

	return (
		<section className="mx-auto max-w-[1440px] px-6 py-8 xl:px-8">
			<div className="bg-ink relative overflow-hidden rounded-3xl">
				<DiamondGrid color="var(--color-brand)" opacity={0.3} masks={[diamondGlows({ x: '30%', y: '60%' })]} />

				<div className="relative grid items-center gap-8 p-10 md:p-[79px] lg:grid-cols-[933fr_600fr]">
					<div className="flex flex-col items-start gap-4">
						<h2 className="max-w-[578px] text-3xl leading-[1.2] font-medium tracking-[-0.02em] text-white md:text-[2.5rem]">
							{t`Already part of the Worldcoo community?`}
						</h2>
						<p className="max-w-[517px] text-base leading-[1.5] text-[#a8acab]">
							<Trans>
								Access your <span className="font-semibold">NGO Area</span> to check your active campaigns, real-time
								fundraising and upload your projects
							</Trans>
						</p>
						<PillLink variant="white" href={ngoArea('/login')}>{t`Go to your NGO Area`}</PillLink>
					</div>

					{/* A changed capture gets a new path (`-generic`): swapped in place, caches kept serving WWF's. */}
					<div className="relative hidden lg:block">
						<img
							src="/redesign/partner-ngos/ngo-dashboard-generic.png"
							alt={t`The Worldcoo NGO Area dashboard`}
							className="absolute top-1/2 left-0 w-[781px] max-w-none -translate-y-1/2 rounded-xl"
							width={781}
							height={459}
						/>
					</div>
				</div>
			</div>
		</section>
	);
}
